"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizationItem = void 0;
let LocalizationItem = exports.LocalizationItem = /*#__PURE__*/function (LocalizationItem) {
  LocalizationItem["Hello"] = "Hello";
  LocalizationItem["SignOut"] = "SignOut";
  LocalizationItem["UpgradeToConsultant"] = "UpgradeToConsultant";
  LocalizationItem["UpgradeToBrandPartner"] = "UpgradeToBrandPartner";
  return LocalizationItem;
}({});